import React from "react";
import Link from "next/link";

import { AppSidebarNav } from "./AppSidebarNav";
import UserControls from "./UserControls";

// sidebar nav config
import navigation from "../_nav";
import { useAxios } from "../http-client/AxiosContext";
import { filterNavByScopes } from "../auth/navFilter";
import { isDoctorTier } from "../auth/scopes";

// Glass shell sidebar. Desktop-only: fixed, always-visible 60-wide rail
// (tw:hidden tw:lg:flex). On mobile the bottom tab nav + header (user menu +
// bell) handle navigation, so there's no off-canvas drawer.
const AppSidebar = () => {
  const { grantedScopes } = useAxios();

  // Doctors don't see a doctors list: relabel their /doctor entry "Mi cuenta"
  // (the page redirects them to their own estado de cuenta).
  const navItems = filterNavByScopes(navigation, grantedScopes).map((item) =>
    isDoctorTier(grantedScopes) && item.to === "/doctor"
      ? { ...item, name: "Mi cuenta" }
      : item,
  );

  return (
    <aside
      className={
        "tw:fixed tw:inset-y-0 tw:left-0 tw:z-40 tw:w-60 tw:flex-col " +
        // Desktop-only rail. On mobile the bottom tab nav + header (user menu +
        // bell) cover navigation, so the off-canvas drawer is gone entirely.
        // Keep the glass bg/blur but neutralize .glass's all-side border + shadow
        // (which doubled lines against the header); a single right border is the
        // only divider the rail needs.
        "tw:hidden tw:lg:flex tw:glass tw:border-0! tw:border-r! tw:border-glassborder! tw:shadow-none! tw:rounded-none!"
      }
    >
      {/* Brand row — the customer's logo. The PNG is monochrome black on
          transparent; `.brand-logo` inverts it to white under html.dark (see
          tailwind.css) so it stays legible on the dark glass. */}
      <div className="tw:flex tw:h-20 tw:items-center tw:justify-center tw:px-4">
        <Link href="/" className="tw:flex tw:items-center tw:justify-center tw:no-underline">
          <img
            src="/web/brand/logo.png"
            alt="Laboratorio Dental MB"
            className="brand-logo tw:h-14 tw:w-auto"
          />
        </Link>
      </div>

      <AppSidebarNav items={navItems} />

      {/* Footer hosts the user menu (dev persona switcher + logout). */}
      <div className="tw:mt-auto tw:border-t tw:border-glassborder tw:p-2">
        <UserControls showName className="tw:w-full tw:text-text-muted" />
      </div>
    </aside>
  );
};

export default React.memo(AppSidebar);
